import React from 'react';
import './styles/section-facilities.css';

const SectionFacilities = () => {
  return (
    <section className='section-facilities comman_sec'>

      <div className='header-navbar-wrapper'>
        <ul className="nav navbar-nav">
          <li>
            <a href="/facilities">Facilities</a>
          </li>
        </ul>
      </div>

    </section>
  );
};

export default SectionFacilities;